import React, { Component } from "react";

export default class ProjectToTop extends Component {
	
	constructor(){
		super()
		this.onIntersection = this.onIntersection.bind(this)
		this.handleScroll = this.handleScroll.bind(this)
		this.state = {
			inView: false,
		}
	}
    
    componentDidMount() {
		if (this.$box) {
			let loadObserver;
			let options = {
				root: null,
				rootMargin: "-20% 0px -20% 0px",
				threshold: 0
			};
			let observer = new IntersectionObserver(this.onIntersection, options);
			observer.observe(this.$box);
		}
	}

	onIntersection(entries, observer) {
	    entries.map((entry) => {
			if (entry.intersectionRatio > 0 && this.state.inView === false) {
				this.setState({ inView: true });
			}						
		});
	}  
	
    handleScroll(evt) { 
	    evt.preventDefault();
	    window.scroll({
			top: 0,
			behavior: "smooth"
  		});
    }
  	
	render () {
										
	    return (
		    
		    <div className={'c-page__block ' + (this.state.inView ? "state-in-view" : "")} ref={(box) => { this.$box = box; }}>
		    
				<div className="c-project__back-to-top">
					<a href="#" className="c-project__back-to-top__button" onClick={this.handleScroll} dangerouslySetInnerHTML={{__html:'<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.691999 13.1752L7.067 0.663249L13.442 13.1752L0.691999 13.1752Z" fill="#434341"/></svg>Back to top'}}></a>
				</div>
				
			</div>
			
		)
	}
}
